<script lang="ts">
import { ChooseAudit } from "@/components/contextSelector";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";

import { AuditRepresentation } from "@/lib/apis/replicable/models";
import AuditsResourceApi from "@/lib/apis/replicable/operations/AuditsResourceApi";
import UserRepresentation from "@/lib/keycloak/api/models/UserRepresentation";

import { createParam } from "@/views/audits/utils";

@Component
export default class AuditConditionalNotifier extends Vue {
	@Getter("context/audit")
	public readonly audit!: AuditRepresentation;

	@Getter("login/currentUser")
	public readonly currentUser!: UserRepresentation;

	@Mutation("context/chooseAudit")
	public readonly chooseAudit!: ChooseAudit;

	@Prop({ default: true })
	public readonly checkStarted!: boolean;

	public updating: boolean = false;

	public async startAudit() {
		this.updating = true;

		try {
			let auditorId = this.audit.auditorId;

			if (auditorId == null) {
				auditorId = this.currentUser.id;
			}

			this.chooseAudit(await AuditsResourceApi.update(this.audit.id, {
				...createParam(this.audit),
				status: "IN_PROGRESS",
				auditorId
			}));
		} finally {
			this.updating = false;
		}
	}
}
</script>

<template>
	<article v-if="audit.institutions.length === 0" class="message is-warning">
		<div class="message-body">
			<p>{{ $t("audit.no.institutions") }}</p>
			<router-link :to="{ name: 'audits.institutions', params: { id: audit.id } }" class="button is-default">
				<span class="icon"><span class="fas fa-building"></span></span>
				<span>{{ $t("actions.choose.institutions") }}</span>
			</router-link>
		</div>
	</article>
	<article v-else-if="checkStarted && (audit.status === 'PREPARING' || audit.status === 'READY')" class="message is-warning">
		<div class="message-body">
			<p>{{ $t("audit.not.started") }}</p>

			<div class="buttons">
				<button @click.prevent="startAudit"
				        :disabled="updating"
				        class="button"
				        :class="{ 'is-loading': updating }">
					<span class="icon"><span class="fas fa-play"></span></span>
					<span>{{ $t("actions.start") }}</span>
				</button>
			</div>
		</div>
	</article>
	<div v-else>
		<slot></slot>
	</div>
</template>

<i18n>
{
	"fr": {
		"actions.choose.institutions": "Choisir des établissements",
		"actions.start": "Commencer",
		"audit.not.started": "Vous ne pouvez pas consulter les résultats des contrôles tant que l'audit n'a pas encore commencé.",
		"audit.no.institutions": "Aucun établissement n'est assigné à cet audit."
	}
}
</i18n>
